const MuiCheckboxCheckedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="4" fill="#4785FF" />
    <path
      d="M15.0312 9.2558C15.4422 8.79 16.1532 8.7453 16.6191 9.1562C17.0849 9.5672 17.1296 10.2782 16.7187 10.7441L11.0937 17.1191C10.8821 17.3589 10.5779 17.4976 10.258 17.4999C9.9383 17.5022 9.6323 17.3681 9.4172 17.1315L5.6672 13.0065L5.5947 12.9179C5.2555 12.4594 5.3123 11.8091 5.7434 11.4172C6.1744 11.0256 6.8266 11.0311 7.2507 11.412L7.3327 11.4933L10.2375 14.6882L15.0312 9.2558Z"
      fill="white"
    />
  </svg>
);

export default MuiCheckboxCheckedIcon;
